import * as XLSX from 'xlsx';

interface ExportOptions {
  sheetName?: string;
  headerMap?: Record<string, string>;
}

export const exportToExcel = (data: any[], fileName: string, options: ExportOptions = {}) => {
  // Create a new workbook
  const wb = XLSX.utils.book_new();
  
  // Apply header mapping if provided
  let exportData = [...data];
  if (options.headerMap) {
    exportData = data.map(item => {
      const newItem: Record<string, any> = {};
      Object.entries(item).forEach(([key, value]) => {
        const newKey = options.headerMap?.[key] || key;
        newItem[newKey] = value;
      });
      return newItem;
    });
  }
  
  // Convert data to worksheet
  const ws = XLSX.utils.json_to_sheet(exportData);
  
  // Add the worksheet to the workbook
  XLSX.utils.book_append_sheet(wb, ws, options.sheetName || 'Datos');
  
  // Generate Excel file and trigger download
  XLSX.writeFile(wb, `${fileName}.xlsx`);
};

export const prepareClientDataForExport = (clients: any[]) => {
  return clients.map(client => ({
    'ID': client.id,
    'Nombre': client.name,
    'Canal': client.channel,
    'GEC': client.gec,
    'Tiene Móvil': client.has_mobile ? 'Sí' : 'No',
    'Tiene Email': client.has_email ? 'Sí' : 'No',
    'Tiene Ubicación': client.has_geo_position ? 'Sí' : 'No',
    'Estado': client.enabled ? 'Habilitado' : 'Deshabilitado',
    'Razón Social': client.legal_name || 'No disponible',
    'Dirección': client.street_name ? `${client.street_name} ${client.street_number || ''}`.trim() : 'No disponible',
    'Localidad': client.locality || 'No disponible',
    'Código Postal': client.zip || 'No disponible',
    'Provincia': client.region_description || 'No disponible',
    'Teléfono': client.phone_number || 'No disponible',
    'Móvil': client.mobile_number || 'No disponible',
    'Email': client.email || 'No disponible',
    'CUIT': client.cuit || 'No disponible'
  }));
};

export const prepareProductDataForExport = (products: any[]) => {
  return products.map(product => ({
    'ID': product.id,
    'Nombre': product.name,
    'Descripción': product.description || 'Sin descripción',
    'Precio': product.price ? new Intl.NumberFormat('es-AR', {
      style: 'currency',
      currency: 'ARS'
    }).format(product.price) : '$0.00',
    'Stock': product.stock || 0,
    'Categoría': product.category || 'Sin categoría',
    'SKU': product.sku || 'No especificado',
    'Código de Barras': product.barcode || 'No especificado',
    'Estado': product.enabled ? 'Activo' : 'Inactivo',
    'Fecha de Creación': product.created_at || 'No disponible',
    'Última Actualización': product.updated_at || 'No disponible'
  }));
};
